import { render, staticRenderFns } from "./MessageResponse.vue?vue&type=template&id=9fd18db2&scoped=true&"
import script from "./MessageResponse.vue?vue&type=script&lang=js&"
export * from "./MessageResponse.vue?vue&type=script&lang=js&"
import style0 from "./MessageResponse.vue?vue&type=style&index=0&id=9fd18db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd18db2",
  null
  
)

export default component.exports